declare global {
  interface Navigator {
    globalPrivacyControl?: boolean;
  }
}

export function isGPCEnabled(): boolean {
  if (typeof navigator === 'undefined') return false;
  return navigator.globalPrivacyControl === true;
}
